import UtilService from "../services/util.service";

export default {
  name: "formatDateClient",
  fn: (utcDateString, format, client) => {
    return UtilService.formatDateClient(utcDateString, format, client);
  }
};
